<script lang="ts">
    export let progressPercent = 0;
</script>

<div
    class={'mx-auto mt-6 h-5 max-w-[240px] rounded-full border-[3px] border-progress-bar-outer bg-progress-bar-inner ' +
        'p-[3px] desktop:h-[26px] desktop:max-w-xs'}
>
    <div class="h-full w-full">
        <div
            class={'progress-bar transition-width relative z-10 h-full w-full overflow-hidden rounded-full ' +
                'bg-progress-bar-gradient duration-500'}
            style:width="{progressPercent}%"
        />
    </div>
</div>

<style>
    .progress-bar:after {
        content: '';
        position: absolute;
        top: 0px;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: linear-gradient(
            -45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent
        );
        background-size: 24px 24px;
        overflow: hidden;
        animation: 1s linear infinite progress-bar-animate;
    }

    @keyframes progress-bar-animate {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 1px 24px;
        }
    }
</style>
